import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['turnInputs', 'limitNumberTurnsInput', 'limitNumberOfTurnsCheckbox', 'select']

  removeField(event) {
    event.preventDefault()
    const fieldId = event.currentTarget.dataset.fieldId

    const destroyCheckbox = document.getElementById(`destroy_${fieldId}`);
    if (destroyCheckbox) destroyCheckbox.checked = true;

    const currentCardType = event.currentTarget.dataset.cardType
    let cards = Array.from(document.getElementsByClassName(`${currentCardType}-card`))
    let index_deleted_card = cards.indexOf(document.getElementById(`block-${fieldId}`))
    let need_update_cards = cards.slice(index_deleted_card + 1)

    need_update_cards.forEach(element => {
      element.querySelector('#position_field').value = element.querySelector('#position_field').value - 1
      element.querySelector('#position_view span').innerHTML = parseInt(element.querySelector('#position_view').textContent) - 1
    });

    let current_card = document.getElementById(`block-${fieldId}`)

    if (destroyCheckbox) {
      destroyCheckbox.checked = true;
      current_card.style.display = 'none';
    } else {
      current_card?.remove();
    }

    this.updateAddFieldBtnPathParam(currentCardType);
  }

  checkTemplateConfirmation(event) {
    const interactionCards = Array.from(document.getElementsByClassName("interaction-card")).filter((card) => getComputedStyle(card).display !== 'none').length
    const confirmModal = interactionCards > 0
    const url = new URL(event.target.href)
    confirmModal ? url.searchParams.set("confirm_modal", 'true') : url.searchParams.delete("confirm_modal")
    event.target.setAttribute("href", url.toString())
  }

  incrementPosition(event) {
    const currentTarget = event.currentTarget;
    setTimeout(() => {
      const url = new URL(currentTarget.href)
      const currentPos = parseInt(url.searchParams.get(`${currentTarget.dataset.type}_position`)) || 0
      url.searchParams.set(`${currentTarget.dataset.type}_position`, currentPos + 1)
      currentTarget.href = url.toString()
    }, 10);
  }

  updatePosition(event) {
    const clickedLink = event.currentTarget;
    const cardType = clickedLink.dataset.type;

    const cards = Array.from(document.getElementsByClassName(`${cardType}-card`))
      .filter(card => {
        const destroyCheckbox = card.querySelector('.destroy-checkbox');
        return !(destroyCheckbox && destroyCheckbox.checked);
      });

    const nextPosition = (cards.length || 0) + 1;
    const links = Array.from(this.element.querySelectorAll(`a[data-type='${cardType}']`));

    links.forEach(link => {
      const url = new URL(link.href);
      url.searchParams.set(`${cardType}_position`, nextPosition);
      link.href = url.toString();
    });
  }

  swapCard(event) {
    let cards = Array.from(document.getElementsByClassName(`${event.currentTarget.dataset.cardType}-card`)).filter((card) => getComputedStyle(card).display !== 'none')
    const currentIndex = cards.findIndex(card => card.contains(event.currentTarget));

    let neighborIndex;

    if (currentIndex === -1) return;
    if(event.currentTarget.dataset.move == 'up') {
      neighborIndex = currentIndex - 1;
      if (neighborIndex < 0) return;
    } else {
      neighborIndex = currentIndex + 1;
      if (neighborIndex >= cards.length) return;
    }
    const currentCard = cards[currentIndex];
    const neighborCard = cards[neighborIndex];

    if (event.currentTarget.dataset.move === 'up') {
      currentCard.parentNode.insertBefore(currentCard, neighborCard);
    } else {
      currentCard.parentNode.insertBefore(neighborCard, currentCard);
    }

    const currentPosition = currentCard.querySelector('#position_field').value
    const neighborPosition = neighborCard.querySelector('#position_field').value

    this.setCardPosition(currentCard, neighborPosition)
    this.setCardPosition(neighborCard, currentPosition)
  }

  setCardPosition(element, position) {
    element.querySelector('#position_field').value = position
    element.querySelector('#position_view span').innerHTML = position
  }

  updateAddFieldBtnPathParam(currentCardType) {
    const cardsByType = Array.from(document.getElementsByClassName(`${currentCardType}-card`)).filter(card => {
      const checkbox = card.querySelector('.destroy-checkbox');
      return !(checkbox && checkbox.checked);
    });

    let last_element = cardsByType[cardsByType.length - 1]
    let last_position = last_element?.querySelector('#position_field')?.value || 0
    let link = document.querySelector(`a[data-type='${currentCardType}']`)

    const url = new URL(link.href)
    url.searchParams.set(`${link.dataset.type}_position`, parseInt(last_position) + 1)
    link.href = url.toString()
  }

  toggleMultipleTurns(event) {
    this.turnInputsTarget.classList.toggle('hidden', !event.currentTarget.checked)

    if (!event.currentTarget.checked) {
      Object.assign(this.limitNumberTurnsInputTarget, { value: null, innerHTML: '', readOnly: true });
      this.limitNumberOfTurnsCheckboxTarget.checked = false;
    }
  }

  toggleLimitMultipleTurns(event) {
    let readonly = !event.currentTarget.checked
    this.limitNumberTurnsInputTarget.readOnly = readonly;
    if(readonly) Object.assign(this.limitNumberTurnsInputTarget, { value: null });
  }

  submitTypeSelection(event) {
    let selectElement = event.target;
    let fieldId = selectElement.dataset.fieldId
    let cardType = selectElement.dataset.cardType

    fetch(`/form_templates/select_card_type?field_id=${fieldId}`, {
      method: 'POST',
      body: new URLSearchParams({
        field_id: fieldId,
        card_type: cardType,
        field_type: selectElement.value
      }),
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
      .then(response => response.text())
      .then(html => {
        Turbo.renderStreamMessage(html);
      });
  }
}
